import exportedUrls from "./urls";
import store from "../../redux/store";
import { toastr } from "react-redux-toastr";
import { trackEvent } from "../config/analytics";
import { updateProductTour } from "../../redux/actions/productTourActions";

export const defaultPricing = {
  growth_yearly_inr: 30000,
  growth_half_yearly_inr: 21000,
  growth_quarterly_inr: 9000,
  growth_monthly_inr: 3000,
  growth_yearly_usd: 1200,
  growth_quarterly_usd: 450,
  growth_monthly_usd: 200,
};

export const getFrequencyBySubsPeriod = (subsPeriod) => {
  switch (subsPeriod) {
    case "Monthly":
      return "month";
    case "Quarterly":
      return "quarter";
    case "Half_Yearly":
      return "half_yearly";
    case "Yearly":
      return "year";
    case "9 months":
      return "nine_months";
    case "2 Years":
      return "two_years";
    case "3 Years":
      return "three_years";
    case "5 Years":
      return "five_years";
    default:
      return "year";
  }
};

export const getSubsPeriodText = (subsPeriod) => {
  switch (subsPeriod) {
    case "Monthly":
      return "1 month";
    case "Quarterly":
      return "3 months";
    case "Half_Yearly":
      return "6 months";
    case "9 months":
      return "9 months";
    case "Yearly":
      return "12 months";
    case "2 Years":
      return "2 Years";
    case "3 Years":
      return "3 Years";
    case "5 Years":
      return "5 Years";
    default:
      return "-";
  }
};

export const getMemberPermission = (
  action,
  field,
  featureKey,
  permissions = []
) => {
  const featurePermissions = permissions?.find((perm) => perm?.[featureKey]);

  const permByFieldAndAction = featurePermissions?.[featureKey]?.find(
    (ques) => ques?.action === action && ques?.field?.includes(field)
  );

  return permByFieldAndAction?.inverted || false;
};

export const getPercentage = (numerator, denominator, decimalPlaces) => {
  numerator = formatNumber(numerator, decimalPlaces);
  denominator = formatNumber(denominator, decimalPlaces);

  return denominator > 0
    ? formatNumber((numerator * 100) / denominator, decimalPlaces)
    : 0;
};

export const getRandomInt = () => Math.floor(Math.random() * 1000000000);

export const getUppercaseWord = (word) =>
  word?.[0]?.toUpperCase() + word?.slice(1, word?.length);

export const getRegexFrmStr = (str) => {
  const obj2 = JSON.parse(str);
  return new RegExp(obj2?.source, obj2?.flags);
};

// objects in arrOfObjs should be like {value: 2.12, label: "Points Earned"}
export const isValidationErrorForDecimal = (
  arrOfObjs = [],
  decimalPlaces = 0
) => {
  let errorsArr = [];
  arrOfObjs?.forEach((obj) => {
    // Check if the decimal value exceeds the allowed decimal places
    const decimalPartLength = (obj?.value?.toString()?.split(".")[1] || "")
      .length;

    if (decimalPartLength > decimalPlaces) {
      errorsArr.push(obj);
    }
  });

  if (errorsArr?.length > 0) {
    const errorString =
      decimalPlaces === 0
        ? `Decimals values are not accepted.`
        : `Upto ${decimalPlaces} decimals values are accepted.`;
    toastr.error(
      errorString,
      `Affected inputs: ${errorsArr?.map((obj) => obj?.label)?.join(", ")}`
    );

    return true;
  }

  return false;
};

export const checkIfFormCompleted = (formData) => {
  for (const key in formData) {
    if (!formData[key]) {
      return false;
    }
  }
  return true;
};

export const isChannelAvailableInCountry = (
  channelName,
  regUserCountry,
  activeChannelForCountries
) => activeChannelForCountries?.[regUserCountry]?.includes(channelName);

export const allSettledPromisePolyfill = (promises) => {
  if (!Promise.allSettled) {
    Promise.allSettled = (promises) =>
      Promise.all(
        promises.map((promise) =>
          promise
            .then((value) => ({
              status: "fulfilled",
              value,
            }))
            .catch((reason) => ({
              status: "rejected",
              reason,
            }))
        )
      );
  }

  return Promise.allSettled(promises);
};

export const showSubscriptionNotification = (
  queryString,
  activePlan,
  fromImportCustomers
) => {
  const query = new URLSearchParams(queryString);
  const status = query.get("status");
  const forWhichBill = query.get("for");
  const userEmail = store.getState()?.auth?.user?.email;
  if (forWhichBill === "credits") {
    if (status === "success") {
      trackEvent("CreditRefilledSuccessfully");
      toastr.success(
        "Success",
        fromImportCustomers
          ? "Your credits have been added to your account. Upload the csv file again and import your customers."
          : "Your payment is successful! Your credits have been added to your account."
      );
    }
    if (status === "failed")
      toastr.error(
        "Success",
        "Your payment has failed. Please try again or contact our support."
      );
    if (status === "pending") {
      toastr.info(
        "Pending",
        "Your payment is under process. You’ll be notified on your email once there’s an update. Your credits will be refilled once the payment is successful."
      );
    }
  } else if (forWhichBill === "subscriptions") {
    const pricePps = store.getState()?.productTour?.pricingPopups;
    store.dispatch(
      updateProductTour("pricingPopups", {
        ...pricePps,
        foreverFreeAfterPaidPlan: true,
        growth: {
          Day15th: false,
          last7thDay: false,
          last3rdDays: false,
          gracepopup: "",
        },
      })
    );
    if (status === "success") {
      // window.analytics.track("SubscriptionUpdated", {
      //   email: userEmail,
      //   plan: activePlan?.plan,
      //   amount: activePlan?.amount,
      //   subs_id: activePlan?.subscription_id,
      //   frequency: activePlan?.subscription_period,
      // });
      toastr.success(
        "Success",
        `Your payment is successful! You’ve been upgraded to the ${activePlan?.plan} plan.`
      );
      // for first promoter
      window.fpr("referral", { email: userEmail });
    }
    if (status === "failed")
      toastr.error(
        "Success",
        "Your payment has failed. Please try again or contact our support."
      );
    if (status === "pending") {
      toastr.info(
        "Pending",
        "Your payment is under process. You’ll be notified on your email once there’s an update. Your credits will be refilled once the payment is successful."
      );
    }
  } else if (forWhichBill === "one-time-setup") {
    // window.analytics.track("CustomHeaderActivation", {
    //   email: userEmail,
    //   paymentStatus: status,
    //   channel: "whatsapp",
    // });
    if (status === "success") {
      toastr.success(
        "Paid Successfully",
        "You can start sending messages from your header once your details gets approved by Meta."
      );
    }
    if (status === "failed")
      toastr.error(
        "Success",
        "Your payment has failed. Please try again or contact our support."
      );
    if (status === "pending") {
      toastr.info(
        "Pending",
        "Your payment is under process. You'll be notified on your email once there's an update."
      );
    }
  }
};

export const getFullImageUrl = (url) =>
  url?.includes("http") || url?.includes("data")
    ? url
    : url
    ? `${exportedUrls.s3BaseUrl}/${url}`
    : "";

export const formatNumber = (val, decimalPlaces = 2) => {
  if (isNaN(val) || val === null) return 0;

  val =
    typeof val === "string"
      ? parseFloat(val)?.toFixed(decimalPlaces)
      : val?.toFixed(decimalPlaces);

  return Number(val);
};

// Converts a hex code to an emoji OR returns the input if it's already an emoji, with error handling for invalid inputs
export const getEmoji = (input) => {
  if (!input) return "";
  try {
    if (/^[0-9A-Fa-f]+$/.test(input)) {
      const emoji = String.fromCodePoint(parseInt(input, 16));
      return emoji;
    } else if (/\p{Emoji}/u.test(input)) return input;
    return ""; // Return empty string for invalid hex codes
  } catch (error) {
    return "";
  }
};

export const getBase64FrmFile = (file) =>
  new Promise(function (resolve, reject) {
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject("Error: ", error);
  });

export const getFileFrmBase64 = (base64, fileName) =>
  new Promise(function (resolve, reject) {
    fetch(base64)
      .then((res) => res.blob())
      .then((blob) => {
        const file = new File([blob], fileName || "logo", {
          type: "image/png",
        });

        resolve(file);
      })
      .catch((error) => reject(error));
  });

export const validateImageDimension = (file, minAllowedWidth) =>
  new Promise((resolve) => {
    let img = new Image();
    img.src = window.URL.createObjectURL(file);
    img.onload = () => {
      const width = img.naturalWidth;
      if (width < minAllowedWidth) {
        return resolve(false);
      }
      return resolve(true);
    };
  });

export const redirectToDifferentPage = (url, target) => {
  let a = document.createElement("a");
  document.body.appendChild(a);
  a.style = "display: none";
  a.href = url;
  a.target = target || "_blank";
  a.rel = "noopener noreferrer";
  a.click();
  document?.body?.removeChild(a);
};

export const downloadLink = (url, target, fileName) => {
  let a = document.createElement("a");
  a.href = url;
  a.style = "display: none";
  a.target = target || "_blank";
  a.rel = "noopener noreferrer";
  a.download = fileName || "reelo-download";
  a.click();
};

// critical utils functions for campaign reward

export const findExistingRewardItem = (rewardsArr, store) =>
  rewardsArr?.find((obj) => obj?.store_id === (store?._id || store?.id)) || {};

export const getItemsArrForStore = (storeItem) => {
  const ids = storeItem?.id?.split("~");
  const names = storeItem?.name?.split("~");

  const output =
    ids?.map((value, index) => ({
      id: value,
      name: names[index],
    })) || [];

  return output;
};

export const convertToSingleObjects = (itemsArray = []) => {
  const combinedObjects = {};
  const outputArray = [];

  itemsArray?.forEach((item) => {
    if (item?.store_id in combinedObjects) {
      combinedObjects[item?.store_id]?.id.push(item?.id);
      combinedObjects[item?.store_id]?.name.push(item?.name);
    } else {
      combinedObjects[item?.store_id] = {
        combo: item?.combo,
        id: item?.id?.length > 0 ? [item.id] : [],
        name: item?.name?.length > 0 ? [item.name] : [],
      };
    }
  });

  for (const key in combinedObjects) {
    const combinedItem = combinedObjects[key];
    const id = combinedItem?.id.join("~");
    const name = combinedItem?.name.join("~");

    outputArray.push({
      id: id,
      name: name,
      store_id: key,
      combo: combinedItem?.combo,
    });
  }

  return outputArray;
};

export const convertToMultipleObjects = (itemsArray = []) =>
  itemsArray?.flatMap((item) => {
    if (!item?.combo && item?.id?.length > 0) {
      const ids = item?.id?.split("~");
      const names = item?.name?.split("~");

      return ids?.map((id, index) => ({
        id: id,
        combo: false,
        name: names[index] || "",
        store_id: item?.store_id,
      }));
    }
    return item;
  });

// end

export const getAutoCampVideo = (key) => {
  switch (key) {
    case "customer_first_time_purchase":
      return {
        title: "Activating 'Welcome New Customer' automated marketing campaign",
        link: thirdPartylinks?.welcomeAE,
      };
    case "customer_bring_back":
      return {
        title: "Activating 'Bring Back Customer' automated marketing campaign",
        link: thirdPartylinks?.bringBackAE,
      };
    case "customer_win_back":
      return {
        title: "Activating 'Win Back Customer' automated marketing campaign",
        link: thirdPartylinks?.winBackAE,
      };
    case "customer_birthday":
      return {
        title:
          "Activating 'Celebrate Customer Birthday' automated marketing campaign",
        link: thirdPartylinks?.birthdayAE,
      };
    case "customer_anniversary":
      return {
        title:
          "Activating 'Celebrate Customer Anniversary' automated marketing campaign",
        link: thirdPartylinks?.anniversaryAE,
      };
    default:
      break;
  }
};

export const thirdPartylinks = {
  // feedback
  campaignFeedback:
    "https://docs.google.com/forms/d/1bn-RwosvyoU2JrEALtqhmaSNqNd-QCiy92zhppBvsm0/edit",
  customerInsightsFeedback:
    "https://docs.google.com/forms/d/1h4p5rG--1prBXiqgvl7jj2q_KHZkgNjofk7KfWvrywU/edit",

  // social links
  insta: "https://www.instagram.com/getreelo/",
  fb: "https://www.facebook.com/getreelo",
  twitter: "https://twitter.com/getreelo",
  linkedin: "https://www.linkedin.com/company/getreelo",
  youtube: "https://www.youtube.com/@getreelo",

  // gifs
  productFiltersGif:
    "https://reelo-assets.s3.ap-south-1.amazonaws.com/static/gifs/product-filters.gif",

  // videos
  autoCampMainVideo: "https://www.youtube.com/embed/Xz-1pmthVCA",
  autoCampReminderVideo:
    "https://www.loom.com/embed/6cef703934f445cd857cf689814fb6ff?sid=4f253cc8-e465-444a-a99b-e92d2e52195e",
  campFrmScratch: "https://www.loom.com/embed/a64a4986f8854600925e50a50a3337f2",
  campFrmScratchSuccess: "https://www.youtube.com/embed/uk04oFJOm7I",
  campaignGettingStarted: "https://www.youtube.com/embed/92-m8VtueZI",
  campaignCarouselDemo:
    "https://www.youtube.com/embed/K4-AVmzMSYk?si=VzPblB3a6537GNMF",
  editEmailCampaign:
    "https://www.loom.com/embed/a6bb54721986491fbde4901fb42eac4b",
  editSmsCampaign:
    "https://www.loom.com/embed/a28e13b1b48c46b7ac6389f7d3abd43a",
  cashierAccount: "https://www.loom.com/embed/e590003e6b194a3282787b4db901c428",
  getStartedWithCashier:
    "https://www.loom.com/embed/0d65faf0fbca482393c4ed5a93f7a564",
  getStartedWithCashier2: "https://youtube.com/embed/LINadvOGo8U",
  campaignRedemption: "https://youtube.com/embed/U_O_FQMHH1s",
  addCustomers: "https://www.loom.com/embed/a6c67d9a06e24d4db6ca52710497e4f8",
  productDemo: "https://www.loom.com/embed/e322e455bdec4bb8ab8be24a27d1b1da",
  whyRefill: "https://www.youtube.com/embed/mdOeZvbn3LY",
  howToRefill: "https://www.youtube.com/embed/Gaug8y0Pzac",
  understandPricing: "https://www.youtube.com/embed/JDtH23kC2uo",

  // custom sms header videos
  entityId: "https://www.youtube.com/embed/xMW8K9SlNk4",
  dltHeader: "https://www.youtube.com/embed/drlftVgLyjE",
  dltHeaderId: "https://www.youtube.com/embed/U0KsklGwxLQ",
  linkHeaderToReelo: "https://www.youtube.com/embed/7kus5rPvEVM",
  registeringTemplates: "https://www.youtube.com/embed/UQ8tN9ALh9k",

  // new youtube videos :-
  bookADemoVideo: "https://www.youtube.com/embed/1mws_ZKeEsM",
  youtubeChannel: "https://www.youtube.com/channel/UC_NJlBE4YsynChO0v-39pSw",
  loyaltyVideo: "https://www.youtube.com/embed/0Fh-5igW1ko",
  newFeedbackVideo: "https://www.youtube.com/embed/-2sz05zFBlE",
  customerEnrollmentVideo: "https://www.youtube.com/embed/wwhBoMtnCMI",
  // auto-campaign videos
  anniversaryAE: "https://www.youtube.com/embed/upn1gnjP9hE",
  birthdayAE: "https://www.youtube.com/embed/5uhYUJR54Vc",
  winBackAE: "https://www.youtube.com/embed/0OwkZDxrLtk",
  bringBackAE: "https://www.youtube.com/embed/HMCQR60wFwY",
  welcomeAE: "https://www.youtube.com/embed/ghv2rGFJwNA",
  // add customers videos
  addManualCustomer: "https://www.youtube.com/embed/YExmN02z5tQ",
  importCustomer: "https://www.youtube.com/embed/3BOLADNx-eE",
  cashierVideoPlaylist:
    "https://youtube.com/playlist?list=PL0-rmFeyfWSx9U0DFALrtCKeQdaXXODop",

  // success screen videos
  fbPosistVideo: "https://www.youtube.com/embed/fIjfdea_8cM",
  fbTabletVideo: "https://www.youtube.com/embed/Po3Hhn3qWfw",
  fbEzeePosVideo: "https://www.youtube.com/embed/qFKfLONARt8",
  fbPetpoojaVideo: "https://www.youtube.com/embed/sEYO1NVn2YY",
  fbCashierPortalVideo: "https://www.youtube.com/embed/ERwhqD0xM5s",

  cpEarnPointsVideo: "https://www.youtube.com/embed/LINadvOGo8U",
  cpRedeemPointsVideo: "https://www.youtube.com/embed/U_O_FQMHH1s",

  campNoDiscVideo: "https://www.youtube.com/embed/nK4-hcvPu6c",
  autoCampNoDiscVideo: "https://www.youtube.com/embed/7FvpNtreeGA",
  posistAutoCampRedeem: "https://www.youtube.com/embed/P8N9FFo2fm8",
  ezeeposAutoCampRedeem: "https://www.youtube.com/embed/qFKfLONARt8",

  // posist videos
  posistIntegration:
    "https://www.loom.com/embed/daf57f7735a941e597e6853ef038623e",
  posistMappingItems:
    "https://www.loom.com/embed/257ec4904a36481cb7778440d976c57d",
  posistLoyalty: "https://www.loom.com/embed/e8e6a576d0774b94823bcf626f207e83",
  posistAddLoyaltyPoints: "https://youtube.com/embed/1Gga-Exbbv8",
  posistCampRedempt:
    "https://www.loom.com/embed/3da4c2a2ce204b699ca1acc109666b29",
  // posist articles
  kcPosistLoyalty:
    "https://getreelo.freshdesk.com/support/solutions/articles/70000491039-how-to-add-redeem-loyalty-points-with-posist-integration-",
  kcPosistCampaigns:
    "https://getreelo.freshdesk.com/support/solutions/articles/70000491073-how-to-redeem-campaigns-in-posist-",

  // petpooja videos
  petpoojaIntegration:
    "https://www.loom.com/embed/ffee98f6587d4db0be534f3b1c4bdc11",
  petpoojaMappingItems:
    "https://www.loom.com/embed/7e769d6dcea648a0890c0def8982f6d1",
  petpoojaAddLoyaltyPoints: "https://youtube.com/embed/5HmQgcHQa7w",
  petpoojaLoyalty:
    "https://www.loom.com/embed/42005c76152e498f9a139efa29961870",
  petpoojaCampaign:
    "https://www.loom.com/embed/16e0b9fb3c54427d95343535dcfa6a74",
  // petpooja articles
  kcPetpoojaLoyalty:
    "https://getreelo.freshdesk.com/support/solutions/articles/70000491031-how-to-add-redeem-loyalty-points-with-petpooja-integration-",
  kcPetpoojaCampaign:
    "https://getreelo.freshdesk.com/support/solutions/articles/70000491035-how-to-redeem-campaigns-in-petpooja-",

  // ezeepos videos
  ezeeposAddLoyaltyPoints: "https://youtube.com/embed/qFKfLONARt8",

  forCalendlyDemo: "https://calendly.com/reelo/demo",
  VIDEO_ACADEMY: "https://www.youtube.com/channel/UC_NJlBE4YsynChO0v-39pSw",
  fbBizManagerIdVerification: "https://www.youtube.com/embed/eYteuEQtN0o",
  b2bReferralForm:
    "https://docs.google.com/forms/d/e/1FAIpQLSeECMGblg4ZBcw1rpR1qSamHyvh1JRvmk9cfxFfgf6kltntSQ/viewform",

  // knowledge center article
  kcBaseLink: "https://getreelo.freshdesk.com/support/home",
  kcLoyalty1:
    "https://getreelo.freshdesk.com/support/solutions/articles/70000257844-start-your-loyalty-program-with-reelo",
  kcLoyalty2:
    "https://getreelo.freshdesk.com/support/solutions/articles/70000257936-customize-your-loyalty-landing-page",
  kcLoyalty3:
    "https://getreelo.freshdesk.com/support/solutions/articles/70000299531-introducing-bonus-points",
  kcLoyalty4:
    "https://getreelo.freshdesk.com/support/solutions/articles/70000259303-what-is-points-reminder-",
  kcLoyalty5:
    "https://getreelo.freshdesk.com/support/solutions/articles/70000331043-what-is-points-expiry-",
  kcLoyalty6:
    "https://getreelo.freshdesk.com/support/solutions/articles/70000259351-quick-guide-to-loyalty-communication",
  kcLoyalty7:
    "https://getreelo.freshdesk.com/support/solutions/articles/70000299533-how-to-make-your-loyalty-program-a-success-",
  kcLoyaltyAddOns:
    "https://mirage-bathroom-a1c.notion.site/4-Examples-of-Creative-Reward-Points-Names-2f16067b376646c2ba345891aca8afff",
  kcRedemptionRate:
    "https://getreelo.freshdesk.com/support/solutions/articles/70000299532-why-redemption-rate-is-important-for-loyalty-programs-",
  kcPointsRedeemed:
    "https://getreelo.freshdesk.com/support/solutions/articles/70000303204-reasons-customers-avoid-participating-in-loyalty-programs",
  kcBoostCTA:
    "https://getreelo.freshdesk.com/support/solutions/articles/70000416955-how-to-boost-performance-of-your-rewards-program-",
  kcCashier:
    "https://getreelo.freshdesk.com/support/solutions/articles/70000327599-getting-started-with-capturing-customers",
  kcCustInsights:
    "https://getreelo.freshdesk.com/support/solutions/articles/70000267073-customer-retention-a-peek-into-new-vs-repeat-customers",
  kcCustSegments:
    "https://getreelo.freshdesk.com/support/solutions/articles/70000266972-customer-segmentation-through-rfm-analysis",
  kcDashboard1:
    "https://getreelo.freshdesk.com/support/solutions/articles/70000352429-how-revenue-distribution-helps-increase-retail-sales-",
  kcDashboard2:
    "https://getreelo.freshdesk.com/support/solutions/articles/70000417135-how-to-boost-the-value-generated-from-reelo",
  kcDashboard3:
    "https://getreelo.freshdesk.com/support/solutions/articles/70000352385-how-to-refill-credits",
  kcCampaign1:
    "https://getreelo.freshdesk.com/support/solutions/articles/70000370516-what-is-a-campaign-library-",
  kcCampaign2:
    "https://getreelo.freshdesk.com/support/solutions/articles/70000370545-how-to-edit-a-campaign-template-",
  kcCampaign3:
    "https://getreelo.freshdesk.com/support/solutions/articles/70000370617-audience-selection-for-the-campaign",
  kcCampaign4:
    "https://getreelo.freshdesk.com/support/solutions/articles/70000370633-selecting-the-channel-for-your-next-campaign",
};

export const WappMsgsForAmntSpent = (businessName, branding) => [
  {
    title: "Welcome ",
    subtitle: `This is sent when a customer joins your loyalty program and earns ${
      branding?.length > 0 ? branding : `points`
    } for the first time.`,
    text: `${businessName}

    Dear customer, 
    
    Welcome to ${businessName} Rewards Program 🥳
    
    Thank you for your purchase.
    
    You've earned 100 ${branding?.length > 0 ? branding : `points`} 🎉 
    
    Oh, and exciting news! You've unlocked 2 rewards 😃 Way to go!
    
    See you soon!✨`,
  },
  {
    title: `${
      branding?.length > 0 ? getUppercaseWord(branding) : `Points`
    } earned `,
    subtitle: `This is sent every time a customer earns ${
      branding?.length > 0 ? branding : `points`
    } after they have joined the program.`,
    text: `<b>${businessName}</b>

    Dear customer,
    
    Thank you for your purchase.
     
    You've earned <b>100 ${
      branding?.length > 0 ? getUppercaseWord(branding) : `Points`
    }</b> 🎉 
    Your current balance is <b>2000 ${
      branding?.length > 0 ? getUppercaseWord(branding) : `Points`
    }</b>.💪
    
    You've unlocked <b>2 Rewards</b> 😃 Way to go!
    
    Do <b>share feedback</b> to help us serve you better! 🙌
    
    See you soon!✨`,
  },
  {
    title: `${
      branding?.length > 0 ? getUppercaseWord(branding) : `Points`
    } redemption`,
    subtitle: `This is sent when a customer redeems their ${
      branding?.length > 0 ? branding : `points`
    } for a reward.`,
    text: `<b>${businessName}</b>

    Awesome news! 🎉 You've successfully redeemed a reward for 100 Points. 🥳
    
    Your updated balance is now <b>900 ${
      branding?.length > 0 ? getUppercaseWord(branding) : `Points`
    }</b>. 💪
    
    Click on the link below to discover more amazing rewards you can redeem. 🎁😃
    
    See you soon! ✨`,
  },
  {
    title: `${
      branding?.length > 0 ? getUppercaseWord(branding) : `Points`
    } reminder`,
    subtitle: `This is sent to remind a customer about their ${
      branding?.length > 0 ? branding : `points`
    } balance.`,
    text: `<b>${businessName}</b>

    Dear customer,
     
    You've got <b>100 ${
      branding?.length > 0 ? getUppercaseWord(branding) : `Points`
    }</b> just waiting to be redeemed. 🎁💫
    
    Simply share your number at ${businessName} during your next visit to redeem.
    🎉
    
    See you soon!✨`,
  },
  {
    title: `${
      branding?.length > 0 ? getUppercaseWord(branding) : `Points`
    } expiry`,
    subtitle: `This is sent to alert a customer when their ${
      branding?.length > 0 ? branding : `points`
    } are about to expire.`,
    text: `<b>${businessName}</b>

    Dear customer,
     
    ⚠️Your <b>100 ${
      branding?.length > 0 ? getUppercaseWord(branding) : `Points`
    }</b> are about to EXPIRE on <b>1/1/22</b>.⏰
    
    Simply share your number at ${businessName} during your next visit to redeem.
    
    See you soon!✨`,
  },
];

export const WappMsgsForCashback = (
  businessName,
  currency,
  branding,
  lsAdvCashback
) => [
  {
    title: "Welcome",
    subtitle: `This is sent when a customer joins your loyalty program and earns ${
      branding?.length > 0 ? branding : `cashback`
    } for the first time.`,
    text: lsAdvCashback
      ? `<b>${businessName}</b>
    Dear customer,

Welcome to ${businessName} Rewards Program 🌟

You've earned <b>${
          branding?.length > 0 ? `50 ${branding}` : `${currency}10 as cashback`
        }</b> on your purchase.

As a part of our <b>Gold</b> member, you'll earn <b>${
          branding?.length > 0 ? `50 ${branding}` : `${currency}10 as cashback`
        }</b> on every purchase.

You're <b>${currency}200</b> spent away to unlock next stage.

Click below to check your account & help us serve you better.

See you soon! ✨`
      : `<b>${businessName}</b>

    Dear customer, 
    
    Welcome to ${businessName} Rewards Program 😀
    
    You've earned <b>${
      branding?.length > 0 ? `50 ${branding}` : `${currency}10 as cashback`
    }</b> on your purchase 🥳
    
    Now earn <b>10% ${
      branding?.length > 0 ? `of your bill as ${branding}` : `Cashback`
    }</b> on every purchase!
    
    See you soon!✨`,
  },
  {
    title: `${
      branding?.length > 0 ? getUppercaseWord(branding) : `Cashback`
    } earned`,
    subtitle: `This is sent every time a customer earns ${
      branding?.length > 0 ? branding : `cashback`
    } after they have joined the program.`,
    text: `<b>${businessName}</b>

    Dear customer, 
    
    Thank you for your purchase. You've earned <b>${
      branding?.length > 0 ? `50 ${branding}` : `${currency}10 as cashback`
    }</b> 🥳
    
    Current balance: <b>${
      branding?.length > 0 ? `1000 ${branding}` : `${currency} 1000`
    }</b> to spend 💪
    
    See you soon!✨`,
  },
  {
    title: `${
      branding?.length > 0 ? getUppercaseWord(branding) : `Cashback`
    } redemption`,
    subtitle: `This is sent when a customer redeems their ${
      branding?.length > 0 ? branding : `cashback`
    } for a reward.`,
    text: `<b>${businessName}</b>

    Dear customer,
    
    Awesome news! 🎉 You've successfully redeemed  ${
      branding?.length > 0 ? `50 ${branding}` : `${currency}10 as cashback`
    }. 🥳
    
    Your updated balance is now <b>${
      branding?.length > 0 ? `1000 ${branding}` : `1000 ${currency}`
    }</b>. 💪
    
    See you soon! ✨`,
  },
  {
    title: `${
      branding?.length > 0 ? getUppercaseWord(branding) : `Cashback`
    } reminder`,
    subtitle: `This is sent to remind a customer about their ${
      branding?.length > 0 ? branding : `cashback`
    } balance.`,
    text: `<b>${businessName}</b>

    Dear customer,
     
    You've got <b>${
      branding?.length > 0 ? `100 ${branding}` : `${currency} 100`
    }</b> just waiting to be redeemed. 🎁💫
    
    Simply share your number at ${businessName} during your next visit to redeem.
    🎉
    
    See you soon!✨`,
  },
  {
    title: `${
      branding?.length > 0 ? getUppercaseWord(branding) : `Cashback`
    } expiry`,
    subtitle: `This is sent to alert a customer when their ${
      branding?.length > 0 ? branding : `cashback`
    } is about to expire.`,
    text: `<b>${businessName}</b>

    Dear customer,
     
    ⚠️Your <b>${
      branding?.length > 0 ? `100 ${branding}` : `${currency} 100`
    }</b> are about to EXPIRE on <b>1/1/22</b>.⏰
    
    Simply share your number at ${businessName} during your next visit to redeem.
    
    See you soon!✨`,
  },
  ...(lsAdvCashback
    ? [
        {
          title: "Tier Updates",
          subtitle: `This is sent to notify the customer about their tier upgrade`,
          text: `Dear customer,

Thank you for your purchase at <b>${businessName}</b>.

Congrats! You're now upgraded to a <b>Silver</b> member 🥳 Now, earn <b>${currency} 15 Cashback</b> from your next purchase.

You've earned <b>${currency} 15 Cashback</b>

Current balance: <b>${currency} 500</b> 💪

Click below to see details and help us serve you better.

See you soon!✨
`,
        },
      ]
    : []),
];

export const smsMsgs = (businessName, branding) => [
  {
    title: "Welcome ",
    subtitle:
      "This is sent when a customer joins your loyalty program and earns points for the first time.",
    text: `Welcome to ${businessName} Rewards. Now earn reward ${
      branding?.length > 0 ? branding : `pts`
    } on every purchase. You earned 1050 ${
      branding?.length > 0 ? branding : `pts`
    }. See reward details:`,
  },
  {
    title: "Points earned ",
    subtitle:
      "This is sent every time a customer earns points after they have joined the program.",
    text: `Yay! You earned 1050 ${
      branding?.length > 0 ? branding : `pts`
    } at ${businessName}. Your ${
      branding?.length > 0 ? branding : `pts`
    } bal: 2500. You've 3 rewards to redeem. See reward details:`,
  },
  {
    title: "Points redemption",
    subtitle: "This is sent when a customer redeems their points for a reward.",
    text: `Congrats! You redeemed a reward for 1050 ${
      branding?.length > 0 ? branding : `pts`
    } at ${businessName}. Your ${
      branding?.length > 0 ? branding : `pts`
    } bal: 2000. See reward details:`,
  },
  {
    title: "Points reminder",
    subtitle: "This is sent to remind a customer about their points balance.",
    text: `${businessName}: Hey, you've 2090 loyalty ${
      branding?.length > 0 ? branding : `points`
    } available with us. Visit us soon. See reward details:`,
  },
  {
    title: "Points expiry",
    subtitle:
      "This is sent to alert a customer when their points are about to expire.",
    text: `${businessName}: Alert! Your 20090 loyalty ${
      branding?.length > 0 ? branding : `pts`
    } will EXPIRE on 25MAY'21. Visit us to renew your ${
      branding?.length > 0 ? branding : `pts`
    }. Reward details:`,
  },
];

export const smsMsgsCashback = (
  businessName,
  branding,
  currency,
  lsAdvCashback
) => [
  {
    title: "Welcome ",
    subtitle:
      "This is sent when a customer joins your loyalty program and earns points for the first time.",
    text: lsAdvCashback
      ? `Welcome to ${businessName} Rewards. You've earned ${
          branding?.length > 0 ? branding : `pts`
        } as our Gold member. See rewards details:`
      : `Welcome to ${businessName} Rewards. Earn 20% ${
          branding?.length > 0
            ? `on every bill as ${branding}`
            : `Cashback on every bill`
        }. You earned ${
          branding?.length > 0 ? `100 ${branding}` : `Rs.100 as cashback`
        }. See details`,
  },
  {
    title: "Points earned ",
    subtitle:
      "This is sent every time a customer earns points after they have joined the program.",
    text: `${businessName}:\n Yay! You earned ${
      branding?.length > 0 ? `100 ${branding}` : `Rs.100 as cashback`
    }. Your bal: ${
      branding?.length > 0 ? `150 ${branding}` : `Rs.150`
    }. See details to redeem`,
  },
  {
    title: "Points redemption",
    subtitle: "This is sent when a customer redeems their points for a reward.",
    text: `${businessName}: Congrats! You redeemed ${
      branding?.length > 0 ? `150 ${branding}` : `Rs.150`
    } on your bill. Your Bal: ${
      branding?.length > 0 ? `2500 ${branding}` : `Rs.2500`
    }. See details`,
  },
  {
    title: "Points reminder",
    subtitle: "This is sent to remind a customer about their points balance.",
    text: `${businessName}: Hey, you've ${
      branding?.length > 0 ? `150 ${branding}` : `Rs.150 cashback`
    } to spend on your next purchase! Visit us before it expires. See details`,
  },
  {
    title: "Points expiry",
    subtitle:
      "This is sent to alert a customer when their points are about to expire.",
    text: `Alert! Don't let your ${
      branding?.length > 0 ? `150 ${branding}` : `Rs.150 cashback`
    } at ${businessName}. EXPIRE on 26JAN'21. Visit us to renew them. See details`,
  },
  ...(lsAdvCashback
    ? [
        {
          title: "Tier Updates",
          subtitle:
            "This is sent when a customer joins your loyalty program and earns points for the first time.",
          text: `Congrats! You're now a Platinum member at ${businessName}. You earned ${currency} 150 Cashback. Bal: ${currency} 500. View Rewards:`,
        },
      ]
    : []),
];

export const pricingData = (isSMSAvailable) => [
  {
    title: "Campaigns",
    feature: [
      {
        featureName: "Template Library",
        forFree: true,
        forStarter: true,
        forGrowth: true,
        freeTrial: true,
        hoverText:
          "Choose from a wide selection of pre-built campaign templates for different objectives such as Weekend Special, Promote online orders, Flash Sale etc.",
      },
      {
        featureName: "Branded Campaign Page",
        forFree: true,
        forStarter: true,
        forGrowth: true,
        freeTrial: true,
        hoverText:
          "Your dedicated page for every campaign that gives allows you to share more details of the campaign and customize it in your brand elements. This page goes as a short link inside SMS.",
      },
      {
        featureName: `Campaign via ${isSMSAvailable ? "SMS and" : ""} Email`,
        forFree: true,
        forStarter: true,
        forGrowth: true,
        freeTrial: true,
        hoverText: `You can choose to send out campaigns using ${
          isSMSAvailable ? "SMS and" : ""
        } Email channels to your customers.`,
      },
      {
        featureName: "Advance customer targeting",
        forFree: true,
        forStarter: true,
        forGrowth: true,
        freeTrial: true,
        hoverText:
          "Use our pre-built customer segments to target your campaign to the right customer group.",
      },
      {
        featureName: "Send campaign on advanced filters",
        forFree: true,
        forStarter: true,
        forGrowth: true,
        freeTrial: true,
        hoverText: "",
      },
      {
        featureName: "Campaign via WhatsApp ",
        forFree: false,
        forStarter: false,
        forGrowth: true,
        freeTrial: true,
        hoverText: "",
      },
      isSMSAvailable
        ? {
            featureName: "Campaign via Custom SMS Header ",
            forFree: false,
            forStarter: false,
            forGrowth: true,
            freeTrial: true,
            hoverText: "",
          }
        : {},
      {
        featureName: "Campaign via Custom WhatsApp Header ",
        forFree: false,
        forStarter: false,
        forGrowth: true,
        freeTrial: true,
        hoverText: "",
      },
    ],
  },
  {
    title: "Customer Insights",
    feature: [
      {
        featureName: "Analytics Dashboard",
        forFree: true,
        forStarter: true,
        forGrowth: true,
        freeTrial: true,
        hoverText:
          "Get complete visibility in your business, and customers to make informed decisions.",
      },
      {
        featureName: "Customer Segmentation ",
        forFree: true,
        forStarter: true,
        forGrowth: true,
        freeTrial: true,
        hoverText:
          "Get automated segments based on RFM (Recency, Frequency, Monetary) analysis to know your customers better and improve your re-engagement strategies.",
      },
      {
        featureName: "Behavioral Analytics",
        forFree: true,
        forStarter: true,
        forGrowth: true,
        freeTrial: true,
        hoverText:
          "Get to know how your customers shop and what drives their shopping behaviour",
      },
      {
        featureName: "360 Degree customer profile",
        forFree: true,
        forStarter: true,
        forGrowth: true,
        freeTrial: true,
        hoverText:
          "Know your customer’s shopping habits like their day/time preferences, their favourite product category, their spending habits, the frequency of visits, and so much more to engage them better.",
      },
      {
        featureName: "Customer Activity Report",
        forFree: true,
        forStarter: true,
        forGrowth: true,
        freeTrial: true,
        hoverText:
          "A detailed report on your customer’s activity, from the purchases made to the spend to the frequency of their visits, for the selected time period.",
      },
      {
        featureName: "Import customers",
        forFree: true,
        forStarter: true,
        forGrowth: true,
        freeTrial: true,
        hoverText:
          "Import your existing/past customers in CSV formats and get them to Reelo.",
      },
      {
        featureName: "Export customers",
        forFree: false,
        forStarter: true,
        forGrowth: true,
        freeTrial: true,
        hoverText: "Export your customer profile data in CSV formats",
      },
    ],
  },
  {
    title: "Loyalty Program",
    feature: [
      {
        featureName: "Custom Points Program ",
        forFree: false,
        forStarter: true,
        forGrowth: true,
        freeTrial: true,
        hoverText:
          "Activate your custom loyalty program and give points on either amount spent or visits made.",
      },
      {
        featureName: "Branded Loyalty page",
        forFree: false,
        forStarter: true,
        forGrowth: true,
        freeTrial: true,
        hoverText:
          "Customize your dedicated loyalty page with all the branding elements such as logo, theme colour and name.",
      },
      {
        featureName: "Points Expiry",
        forFree: false,
        forStarter: true,
        forGrowth: true,
        freeTrial: false,
        hoverText: "Set the duration for points expiry period",
      },
      {
        featureName: "Points Reminder",
        forFree: false,
        forStarter: true,
        forGrowth: true,
        freeTrial: false,
        hoverText:
          "Send automated messages to customers to remind them about the available points balance",
      },
      {
        featureName: "Multi-channel communication",
        forFree: false,
        forStarter: true,
        forGrowth: true,
        freeTrial: true,
        hoverText:
          "Send loyalty communication to your customers on Whatsapp, SMS and Email",
      },
      // {
      //   featureName: "Custom header for SMS",
      //   forFree: false,
      //   forStarter: false,
      //   forGrowth: true,
      //   freeTrial: false,
      //   hoverText: "Add your custom 6-digit header to the SMS communication sent to your customers"
      // },
      // {
      //   featureName: "Custom header for Whatsapp",
      //   forFree: false,
      //   forStarter: false,
      //   forGrowth: true,
      //   freeTrial: false,
      //   hoverText: "Add your brand name and logo to the Whatsapp communication that will be sent to your customers"
      // },
      {
        featureName: "Bonus Points",
        forFree: false,
        forStarter: true,
        forGrowth: true,
        freeTrial: true,
        hoverText:
          "Incentivize your customers with extra points for providing details such as email, birth date, and anniversary date",
      },
      {
        featureName: "Points Branding",
        forFree: false,
        forStarter: true,
        forGrowth: true,
        freeTrial: true,
        hoverText: "",
      },
    ],
  },
  {
    title: "Feedback",
    feature: [
      {
        featureName: "Multi-channel Feedback",
        forFree: false,
        forStarter: false,
        forGrowth: true,
        freeTrial: true,
        hoverText:
          "Capture customer feedback through Kiosk (tablet), Whatsapp, SMS and Email.",
      },
      {
        featureName: "Negative feedback alert",
        forFree: false,
        forStarter: false,
        forGrowth: true,
        freeTrial: true,
        hoverText:
          "Get Whatsapp and SMS alerts in real-time when a customer gives a negative feedback so you can act on it, before it’s too late.",
      },
      {
        featureName: "Customize to your brand",
        forFree: false,
        forStarter: false,
        forGrowth: true,
        freeTrial: false,
        hoverText:
          "Align the look and feel of your survey with your brand with ease. Add your logo, customize colors, create a branded survey page.",
      },
      {
        featureName: "Increase Online Reviews",
        forFree: false,
        forStarter: false,
        forGrowth: true,
        freeTrial: true,
        hoverText:
          "Capture customer reviews on other platforms like Google, Zomato, TripAdvisor, etc.",
      },
      {
        featureName: "Real-time Feedback analytics",
        forFree: false,
        forStarter: false,
        forGrowth: true,
        freeTrial: true,
        hoverText:
          "Understand feedback insights as soon as someone shares feedback, it is instantly available to you and your team in your dashboard for exploration.",
      },
    ],
  },
  {
    title: "Automated campaigns",
    feature: [
      {
        featureName: "Pre-built Journey's",
        forFree: false,
        forStarter: false,
        forGrowth: true,
        freeTrial: false,
        hoverText:
          "Build personalized communication with every customer on critical moment's of your customer's journey.",
      },
      {
        featureName: "Campaign templates",
        forFree: false,
        forStarter: false,
        forGrowth: true,
        freeTrial: false,
        hoverText:
          "Choose from pre-built templates for each Auto campaign objective to help you set-up within mins.",
      },
      {
        featureName: "Branded Campaign Page",
        forFree: false,
        forStarter: false,
        forGrowth: true,
        freeTrial: false,
        hoverText:
          "Align the look and feel of your Auto Campaign with your brand with ease. Add your logo, customize colors, images and create a branded campaign.",
      },
      {
        featureName: "Campaign analytics",
        forFree: false,
        forStarter: false,
        forGrowth: true,
        freeTrial: false,
        hoverText:
          "Know how successful each Auto campaign is and see how many customers it has brought back and the revenue it has generated easily.",
      },
      {
        featureName: `Campaign ${
          isSMSAvailable ? "via SMS," : ""
        } Email and WhatsApp`,
        forFree: false,
        forStarter: false,
        forGrowth: true,
        freeTrial: false,
        hoverText: `Send Automated campaigns across ${
          isSMSAvailable ? "SMS," : ""
        } Email and Whatsapp at the time best suited for you.`,
      },
      {
        featureName: "Campaign via Custom WhatsApp Header",
        forFree: false,
        forStarter: false,
        forGrowth: true,
        freeTrial: false,
        hoverText: "",
      },
      isSMSAvailable
        ? {
            featureName: "Campaign via Custom SMS Header",
            forFree: false,
            forStarter: false,
            forGrowth: true,
            freeTrial: false,
            hoverText: "",
          }
        : {},
    ],
  },
  {
    title: "QR Code",
    forFree: false,
    feature: [
      {
        featureName: "Generate Custom Codes ",
        forFree: false,
        forStarter: false,
        forGrowth: true,
        freeTrial: true,
        hoverText: "",
      },
      {
        featureName: "QR code Insights ",
        forFree: false,
        forStarter: false,
        forGrowth: true,
        freeTrial: true,
        hoverText: "",
      },
      {
        featureName: "Multiple QR Codes",
        forFree: false,
        forStarter: false,
        forGrowth: true,
        freeTrial: true,
        hoverText: "",
      },
    ],
  },
];

export const demoCountriesSeed = [
  {
    payment_gateway: "Stripe",
    code: "US",
    timezone: "America/Adak",
    country: "United States",
    calling_code: "+1",
    currency: "USD",
    currency_view: "USD$",
    flag: "https://raw.githubusercontent.com/google/region-flags/gh-pages/svg/US.svg",
  },
  {
    payment_gateway: "Stripe",
    code: "CA",
    timezone: "America/Atikokan",
    country: "Canada",
    calling_code: "+1",
    currency: "CAD",
    currency_view: "CAD$",
    flag: "https://raw.githubusercontent.com/google/region-flags/gh-pages/svg/CA.svg",
  },
  {
    payment_gateway: "Stripe",
    code: "GB",
    timezone: "Europe/London",
    country: "United Kingdom",
    calling_code: "+44",
    currency: "GBP",
    currency_view: "£",
    flag: "https://raw.githubusercontent.com/google/region-flags/gh-pages/svg/GB.svg",
  },
  {
    payment_gateway: "Stripe",
    code: "AU",
    timezone: "Antarctica/Macquarie",
    country: "Australia",
    calling_code: "+61",
    currency: "AUD",
    currency_view: "AUD$",
    flag: "https://raw.githubusercontent.com/google/region-flags/gh-pages/svg/AU.svg",
  },
  {
    payment_gateway: "Stripe",
    code: "NZ",
    timezone: "Pacific/Auckland",
    country: "New Zealand",
    calling_code: "+64",
    currency: "NZD",
    currency_view: "NZD$",
    flag: "https://raw.githubusercontent.com/google/region-flags/gh-pages/svg/NZ.svg",
  },
  {
    payment_gateway: "Stripe",
    code: "UAE",
    timezone: "Asia/Dubai",
    country: "United Arab Emirates",
    calling_code: "+971",
    currency: "AED",
    currency_view: "د.إ",
    flag: "https://raw.githubusercontent.com/google/region-flags/gh-pages/svg/AE.svg",
  },
  {
    payment_gateway: "Stripe",
    code: "SG",
    timezone: "Asia/Singapore",
    country: "Singapore",
    calling_code: "+65",
    currency: "SGD",
    currency_view: "SGD$",
    flag: "https://raw.githubusercontent.com/google/region-flags/gh-pages/svg/SG.svg",
  },
  {
    payment_gateway: "Razorpay",
    code: "IN",
    timezone: "Asia/Kolkata",
    country: "India",
    calling_code: "+91",
    currency: "INR",
    currency_view: "₹",
    flag: "https://raw.githubusercontent.com/google/region-flags/gh-pages/svg/IN.svg",
  },
];
